// eslint-disable-next-line import/no-anonymous-default-export
export default {
	BASE_URL: 'http://192.168.110.8:8080',
	SOCKET_URL: 'ws://192.168.110.8:8080/webSocket/',
	SOCKETIO_URL: 'http://192.168.110.8:9999'
}
